angular.module("events")

    .controller("EventsDiaryCtrl", ['event', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state',
        function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_DIARY_WRITE");

            if(!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if(results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }

            $scope.event_id = $stateParams.id;

            //Restangular.one('Events', $stateParams.id).get().then(function (results) {
               // event = results;
                $rootScope.breadcrumb = [
               { title: $filter('translate')('events.title'), url: "events.list" },
               { title: event.name, url: "events.edit({ id: " + event.id + " })" },
               { title: $filter('translate')('events.diary.diary') }
                ];
                $rootScope.title = event.name + " - " + $filter('translate')('events.diary.diary');
            //});


    }])

;
